import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { formatPrice } from '@white-label-helper/helper-payment';
import { TravelInsuranceQuoteDetails } from 'ecommerce/feature-travel-insurance';
import { BOOKING_STATUSES } from '@white-label-configuration/constants';



export default /*#__PURE__*/_defineComponent({
  __name: 'product-summary-travel-insurance-card',
  props: {
    product: null,
    selectedForCancellation: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  product: {
    name: string;
    display_name?: string;
    totals: { total:number };
    status?: string;
    is_cancellable?: boolean;
  };
  selectedForCancellation?: boolean;
};



const isProductCancelled = computed(() => {
  return props.product?.status?.toUpperCase() === BOOKING_STATUSES.CANCELLED;
});

const showCancellationStatus = computed(() => {
  return (props.selectedForCancellation && props.product.is_cancellable) || isProductCancelled.value;
});


return { __sfc: true,props, isProductCancelled, showCancellationStatus, formatPrice, TravelInsuranceQuoteDetails }
}

})